import React from 'react';
import classNames from 'classnames';

import { Props } from './DefaultItem';
import useEnv from 'hooks/useEnv';
import { DEFAULT_AFIBEL_SEPARATOR_CHARACTER } from 'services/product';

import styles from '../ProductDescription.module.scss';

function EcoTexItem({ attrCode, content }: Props): JSX.Element {
  const { mediaProductSheet } = useEnv();
  const ecoTexImg = mediaProductSheet + '/logos_RSE/logo-oekotext.png';

  const [, standard, standardId, laboratory] = content.split(
    DEFAULT_AFIBEL_SEPARATOR_CHARACTER
  );

  return (
    <div className={classNames(styles[attrCode], styles.attrLines)}>
      <div className={styles.ecoTexImg}>
        <img src={ecoTexImg} alt="OEKO TEX" />
      </div>
      <div className={styles.ecoTexInfos}>
        <div className={styles.standard}>{standard}</div>
        <div>{standardId}</div>
        <div>{laboratory}</div>
      </div>
    </div>
  );
}

export default EcoTexItem;
